<script setup>
const { t } = useI18n()

const COOKIE_KEY = 'cookie_consent'
const accepted = useCookie(COOKIE_KEY, {
  maxAge: 60 * 60 * 24 * 365, // 1 рік
  sameSite: 'lax'
})

const visible = ref(false)

onMounted(() => {
  if (!accepted.value) {
    // Невелика затримка щоб не мигало одразу при завантаженні
    setTimeout(() => { visible.value = true }, 800)
  }
})

function accept() {
  accepted.value = 'true'
  visible.value = false
}

function decline() {
  accepted.value = 'false'
  visible.value = false
}
</script>

<template>
  <Teleport to="body">
    <Transition name="cookie-slide">
      <div
        v-if="visible"
        class="right-4 md:right-auto bottom-4 left-4 md:left-4 z-[9998] fixed md:w-[420px]"
        role="dialog"
        aria-live="polite"
        :aria-label="t('cookie.title')"
      >
        <div class="flex flex-col gap-3 bg-neutral shadow-2xl p-4 border border-white/5 rounded-2xl">
          <!-- Заголовок -->
          <div class="flex items-center gap-2">
            <span class="text-lg" aria-hidden="true">🍪</span>
            <p class="font-semibold text-sm text-base-content">{{ t('cookie.title') }}</p>
          </div>

          <!-- Текст -->
          <!-- <p class="text-xs text-base-content/70 leading-relaxed">
            {{ t('cookie.description') }}
          </p> -->

          <!-- Кнопки -->
          <div class="flex gap-2">
            <button
              class="flex-1 btn btn-primary btn-sm"
              @click="accept"
            >
              {{ t('cookie.accept') }}
            </button>
            <button
              class="flex-1 btn btn-ghost btn-sm"
              @click="decline"
            >
              {{ t('cookie.decline') }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.cookie-slide-enter-active,
.cookie-slide-leave-active {
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.cookie-slide-enter-from,
.cookie-slide-leave-to {
  opacity: 0;
  transform: translateY(16px);
}
</style>
